import { Box } from 'modules/af_cm_ui_kit';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';
import { EditableField } from 'modules/cm/fields/EditableField';
import fields, { FIELDS } from 'modules/cm/fields/types';
import React from 'react';
import { SectionProps } from './types';

const BrokerDetailsSection: React.FC<SectionProps> = ({ resources }) => {
  const UpdateableField = (props: React.ComponentProps<typeof EditableField>) => <EditableField {...props} />;

  return (
    <Box title="Broker details">
      <UpdateableField fieldType="text" field={fields[FIELDS.ADVISER_NAME]} />
      {/* <UpdateableField fieldType="text" field={fields[FIELDS.ADVISER_PHONE]} variant={VARIANTS_TYPES.PHONE} /> */}
      <UpdateableField fieldType="text" field={fields[FIELDS.ADVISER_EMAIL]} />
      <UpdateableField fieldType="text" field={fields[FIELDS.FIRM_FCA_NUMBER]} variant={VARIANTS_TYPES.ADVISER_FCA} />
      <UpdateableField fieldType="text" field={fields[FIELDS.FIRM_NAME]} />
      <UpdateableField fieldType="text" field={fields[FIELDS.FIRM_ADDRESS]} />
      <UpdateableField fieldType="text" field={fields[FIELDS.NETWORK_FCA_NUMBER]} />
      <UpdateableField fieldType="text" field={fields[FIELDS.NETWORK_NAME]} />
      <UpdateableField fieldType="text" field={fields[FIELDS.CLUB_NAME]} />
      <UpdateableField
        fieldType="text"
        field={fields[FIELDS.UPFRONT_COMMISSION_AMOUNT]}
        variant={VARIANTS_TYPES.CURRENCY}
      />
      <UpdateableField
        fieldType="text"
        field={fields[FIELDS.ONGOING_COMMISSION_AMOUNT]}
        variant={VARIANTS_TYPES.CURRENCY}
      />
      <UpdateableField fieldType="text" field={fields[FIELDS.ADVISER_FEE]} variant={VARIANTS_TYPES.CURRENCY} />
      <UpdateableField
        fieldType="select"
        field={fields[FIELDS.ADVISER_FEE_LAST_PAYMENT_MOMENT]}
        options={resources.creditFeePayMoment}
      />
      <UpdateableField fieldType="text" field={fields[FIELDS.PACKAGER_FEE]} variant={VARIANTS_TYPES.CURRENCY} />
      <UpdateableField
        fieldType="select"
        field={fields[FIELDS.PACKAGER_FEE_LAST_PAYMENT_MOMENT]}
        options={resources.creditFeePayMoment}
      />
    </Box>
  );
};

export default BrokerDetailsSection;
